import React, { useState } from "react";
import { gallery } from "../mock";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

const Gallery = () => {
  const [lightbox, setLightbox] = useState(null);

  const open = (i) => setLightbox(i);
  const close = () => setLightbox(null);
  const prev = () => setLightbox((i) => (i - 1 + gallery.images.length) % gallery.images.length);
  const next = () => setLightbox((i) => (i + 1) % gallery.images.length);

  return (
    <section id="gallery-section" className="relative py-20 md:py-28 overflow-hidden" style={{ backgroundImage: `url(${gallery.bg})`, backgroundSize: "cover" }}>
      <div className="absolute inset-0 bg-[#f8f2e8]/90" />
      <img src={gallery.flower} alt="" className="ornament left-0 top-10 w-36 opacity-70" />
      <img src={gallery.multiFlowers} alt="" className="ornament right-0 bottom-0 w-40 opacity-70" />
      <div className="relative max-w-[1320px] mx-auto px-5 lg:px-8">
        <div className="section-head">
          <p className="eyebrow">Gallery</p>
          <div className="divider-leaf my-3" />
          <h2 className="h-title">Inspired by Eternity. Designed for Today</h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {gallery.images.map((src, i) => {
            const heights = ["h-52", "h-64", "h-56", "h-72"];
            return (
              <div key={i} className={`gallery-tile ${heights[i % 4]}`} onClick={() => open(i)}>
                <img src={src} alt={`Gallery ${i + 1}`} loading="lazy" />
              </div>
            );
          })}
        </div>
      </div>

      {lightbox !== null && (
        <div className="fixed inset-0 z-[100] bg-black/85 flex items-center justify-center p-4" onClick={close}>
          <button onClick={(e) => { e.stopPropagation(); close(); }} className="absolute top-5 right-5 w-11 h-11 rounded-full bg-white/15 hover:bg-white/25 text-white flex items-center justify-center"><X /></button>
          <button onClick={(e) => { e.stopPropagation(); prev(); }} className="absolute left-5 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/15 hover:bg-white/25 text-white flex items-center justify-center"><ChevronLeft /></button>
          <img src={gallery.images[lightbox]} alt="" className="max-h-[85vh] max-w-[92vw] object-contain rounded-lg" onClick={(e) => e.stopPropagation()} />
          <button onClick={(e) => { e.stopPropagation(); next(); }} className="absolute right-5 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/15 hover:bg-white/25 text-white flex items-center justify-center"><ChevronRight /></button>
        </div>
      )}
    </section>
  );
};

export default Gallery;
